<div class="flex flex-col bg-gray-50 w-full mx-auto font-prompt relative h-full overflow-auto pb-10">
  <!-- 1. ส่วนหัวโค้งมนสีไล่ระดับพรีเมียม ( mockup layout header ) -->
  <div
    class="bg-gradient-to-b from-[#2e2f38] to-[#1a1b20] pb-24 pt-8 px-6 rounded-b-[2.5rem] relative z-10 text-white text-left select-none shadow-md">
    <!-- ปุ่มย้อนกลับ -->
    <div class="flex items-center justify-between mb-6">
      <button (click)="goback()"
        class="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-white/20 active:scale-90 transition-all outline-none">
        <img src="icons/arrow_back_white.svg" class="h-5 w-5" />
      </button>
      <span
        class="text-[10px] font-bold tracking-wider text-amber-400 bg-amber-500/10 px-3 py-1 rounded-full uppercase">
        {{ currentLanguage === 'TH' ? 'กล่องข้อความคำเชิญ' : 'Invitation Inbox' }}
      </span>
    </div>

    <!-- ข้อมูลต้อนรับส่วนตัว ( mock-up header greetings ) -->
    <div class="space-y-1">
      <h1 class="text-lg font-bold leading-tight">
        {{ currentLanguage === 'TH' ? 'คำเชิญแชร์ทะเบียนรถ' : 'Vehicle Share Invites' }}
      </h1>
      <p class="text-[10px] text-gray-400 font-medium">
        {{ currentLanguage === 'TH'
        ? 'ตรวจสอบสิทธิ์การแชร์ใช้ทะเบียนรถยนต์เพื่อตอบรับการใช้งานร่วมกัน'
        : 'Verify shared vehicle access invitations to accept or decline' }}
      </p>
    </div>
  </div>

  <!-- 2. รายการคำเชิญทับซ้อนส่วนหัว ( mockup overlapping container ) -->
  <div class="flex-grow px-4 relative z-20 -mt-12 select-none">
    <div class="bg-white rounded-[2rem] shadow-xl border border-gray-100/50 p-5 h-[calc(100vh-350px)] flex flex-col">

      <!-- หัวข้อหัวรายการ -->
      <div class="flex items-center justify-between mb-4 pb-3 border-b border-gray-50">
        <span class="text-sm font-bold text-gray-700">
          {{ currentLanguage === 'TH' ? 'คำเชิญที่รอดำเนินการ' : 'Pending Invitations' }}
        </span>
        <span class="text-[9px] font-bold text-amber-500 bg-amber-50 px-2 py-0.5 rounded-full">
          {{ invites.length }} {{ currentLanguage === 'TH' ? 'คำขอ' : 'requests' }}
        </span>
      </div>

      <!-- รายการการ์ดคำเชิญ -->
      <div class="space-y-3 flex-grow overflow-y-auto max-h-[60vh] scroll-smooth pr-1 custom-scrollbar">
        <!-- กรณีไม่มีรายการคำเชิญ -->
        <div *ngIf="invites.length === 0" class="flex flex-col items-center justify-center py-20 text-center">
          <div
            class="w-14 h-14 rounded-full bg-gray-100 flex items-center justify-center text-gray-400 mb-3 shadow-inner">
            <img src="icons/mail_slate_dark.svg" />
          </div>
          <p class="text-sm font-bold text-gray-400">{{ currentLanguage === 'TH'
            ? 'ไม่มีคำเชิญรอตอบรับ'
            : 'No pending invitations' }}</p>
          <p class="text-[10px] text-gray-400 mt-1">{{ currentLanguage === 'TH'
            ? 'เมื่อมีใครแชร์ทะเบียนรถมาหาคุณคำขอจะแสดงขึ้นที่นี่'
            : 'Shared vehicle invite requests will appear here' }}</p>
        </div>

        <!-- การ์ดรายการคำเชิญ -->
        <div *ngFor="let invite of invites"
          class="bg-white border border-gray-100 rounded-2xl p-4 shadow-sm space-y-4 hover:shadow-md transition-all duration-300">
          <!-- ส่วนข้อมูลคนส่ง & ทะเบียน -->
          <div class="flex items-start gap-3">
            <div class="w-10 h-10 rounded-xl bg-amber-50 text-amber-500 flex items-center justify-center flex-shrink-0">
              <img src="icons/directions_car_orange.svg" />
            </div>

            <div class="flex-1 min-w-0 text-left">
              <div class="flex items-center justify-between">
                <span class="text-[10px] font-bold text-amber-500 bg-amber-500/10 px-2 py-0.5 rounded-full uppercase">
                  {{ currentLanguage === 'TH' ? 'รอตัดสินใจ' : 'Pending' }}
                </span>
                <span class="text-[9px] text-gray-400 font-bold">#{{ invite.id }}</span>
              </div>
              <h3 class="text-sm font-bold text-gray-800 truncate mt-1">
                {{ currentLanguage === 'TH' ? 'ทะเบียน' : 'Plate' }}: <span class="text-amber-500">{{ invite.plateNumber
                  }}</span>
              </h3>
              <p class="text-[10px] text-gray-400 font-bold truncate mt-0.5">
                {{ currentLanguage === 'TH' ? 'จาก' : 'From' }}: {{ invite.fromName || ('#' + invite.fromCpUserId) }}
              </p>
            </div>
          </div>

          <!-- ปุ่มกดยอมรับ / ปฏิเสธ -->
          <div class="grid grid-cols-2 gap-3">
            <button (click)="reject(invite)"
              class="w-full bg-red-50 hover:bg-red-100 text-red-500 border border-red-100 text-sm font-bold rounded-xl py-2.5 transition-all duration-200 active:scale-95 outline-none">
              {{ currentLanguage === 'TH' ? 'ปฏิเสธ' : 'Reject' }}
            </button>
            <button (click)="accept(invite)"
              class="w-full bg-(--main-color) hover:from-amber-600 hover:to-yellow-500 text-white text-sm font-bold rounded-xl py-2.5 shadow-md transition-all duration-200 active:scale-95 outline-none">
              {{ currentLanguage === 'TH' ? 'ยอมรับสิทธิ์' : 'Accept' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>